const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY, // {API_KEY}
  authDomain: process.env.REACT_APP_AUTH_DOMAIN, // {authDomain}
  databaseURL: process.env.REACT_APP_DB_URL, // {databaseURL}
  projectId: process.env.REACT_APP_PROJECT_ID, // {projectId}
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET, // {storageBucket}
  endpoints: {
    games: 'games.json',
    runs: 'run.json'
  }
};

export default firebaseConfig;